export default "__VITE_ASSET__Cj2XtkR7__"